<script setup>
import { ref } from 'vue';
import api from '../ApiClient.js';

const props = defineProps(['movie', 'schema']);
const emit = defineEmits(['open-diagram']);

let collapsed = ref(false);

function toggleCollapse() {
  collapsed.value = !collapsed.value;
  console.log(collapsed);
}
function getSectionId(sectionName) {
  return `section-${sectionName.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`;
}
function scrollToSection(sectionName) {
  const element = document.getElementById(getSectionId(sectionName));
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
function getScenes(sequence) {
  const scenesRaw = sequence && sequence.scenes ? sequence.scenes : [];
  const scenesArr = Array.from(scenesRaw);
  const allScenes = Array.isArray(props.movie.scenes) ? props.movie.scenes : Array.isArray(props.movie.Scene) ? props.movie.Scene : [];
  if (!sequence) return [];
  return scenesArr
    .map((idOrObj) => {
      if (typeof idOrObj === 'object') return idOrObj;
      return allScenes.find((scene) => scene.id === idOrObj);
    })
    .filter(Boolean);
}
function getShots(scene) {
  const shotsRaw = scene && scene.shots ? scene.shots : [];
  const shotsArr = Array.from(shotsRaw);
  const allShots = Array.isArray(props.movie.shots) ? props.movie.shots : Array.isArray(props.movie.Shot) ? props.movie.Shot : [];
  if (!scene) return [];
  return shotsArr
    .map((idOrObj) => {
      if (typeof idOrObj === 'object') return idOrObj;
      return allShots.find((shot) => shot.id === idOrObj);
    })
    .filter(Boolean);
}
function handleSidebarClick(type, id) {
  const el = document.getElementById(`${type}-${id}`);
  if (el) {
    let parent = el;
    while (parent) {
      if (parent.classList && parent.classList.contains('accordion-item')) {
        parent.classList.add('open');
      }
      parent = parent.parentElement;
    }
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
async function generateShot(shotId) {
  try {
    const response = await api.makeShot(props.movie.id, shotId);
    const prompt = response.prompt;

    // Copy to clipboard
    if (!confirm('Copy to clipboard?\nOtherwise you may want to check the browser developer console')) {
      console.log(prompt);
      alert(prompt);
    } else navigator.clipboard.writeText(prompt);
  } catch (error) {
    console.error('Failed to generate shot prompt:', error);
    alert('Failed to generate shot prompt: ' + error.message);
  }
}
</script>
<template>
  <aside class="sidebar" :class="{ open: movie, collapsed }">
    <div class="sidebar-header">
      <h3>{{ movie?.name }}</h3>
      <button class="close-btn icon" @click="toggleCollapse()">{{ collapsed ? 'account_tree' : 'close' }}</button>
    </div>
    <div v-if="movie" class="sidebar-content toc">
      <button class="icon" @click="$emit('open-diagram')">account_tree</button>
      <ul>
        <li><a href="#" @click.prevent="scrollToSection('movie-details')">Movie Details</a></li>
        <li>
          <a href="#" @click.prevent="scrollToSection('Sequence')">Sequence</a>
          <ul v-if="movie.Sequence && movie.Sequence.length">
            <li v-for="sequence in movie.Sequence" :key="sequence.id">
              <a href="#" @click.prevent="handleSidebarClick('Sequence', sequence.id)">
                {{ sequence.name || 'Untitled Sequence' }}
              </a>
              <ul v-if="getScenes(sequence).length">
                <li v-for="scene in getScenes(sequence)" :key="scene.id">
                  <a href="#" @click.prevent="handleSidebarClick('Scene', scene.id)">
                    {{ scene.name || 'Untitled Scene' }}
                  </a>
                  <ul v-if="getShots(scene).length">
                    <li v-for="shot in getShots(scene)" :key="shot.id" class="shot-item">
                      <a href="#" @click.prevent="handleSidebarClick('Shot', shot.id)">
                        {{ shot.name || 'Untitled Shot' }}
                      </a>
                      <button class="icon" @click="generateShot(shot.id)">camera</button>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          <span v-else class="warning">No sequences</span>
        </li>
        <li v-for="relation in Object.keys(schema).filter((f) => schema[f].showForm && f != 'Sequence')" :key="relation">
          <a href="#" @click.prevent="scrollToSection(relation)">{{ relation }}</a>
        </li>
      </ul>
    </div>
  </aside>
</template>
